/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Internal origin of the create request. `standard` means a normal create endpoint calculated the totals. `custom` means the document was created through a `/custom` endpoint.
 */
export type CreationSource = typeof CreationSource[keyof typeof CreationSource];


export const CreationSource = {
  standard: 'standard',
  custom: 'custom',
} as const;
